import React, { lazy } from 'react'
import { App, AuthorizableModal } from '@reactiveonline/frontend_shared_components'
import HeaderIcons from './header/HeaderIcons'
import { dynamicBlocks } from './builder/dynamicBlocks'

// pass 'packageComponent' if the component should be imported inside the package

export default function AppLayout(props) {
  let PageContent = null
  if (!props.packageComponent) {
    PageContent = lazy( () => import(`./${ props.componentPath }`) )
  }

  return (
    <App
      { ...props }
      packageComponent={ props.packageComponent && !props.appProps.notAuthorized }
      PageContent={ props.appProps.notAuthorized ? AuthorizableModal : PageContent }
      appProps={{
        ...props.appProps,
        HeaderIcons: HeaderIcons,
        dynamicBlocks: props.appProps.newBuilderEnabled ? dynamicBlocks : null
      }}
    />
  )
}
